const getters = {
  loaded: state => state.loaded,
  surveys: state => state.surveys,
  survey: state => state.survey,
  primaryLanguage: state => state.survey.primaryLanguage
};

export default getters;
